export const createDynatraceWebService = (applicationName, onErrorCallBack) => {
    const dtrum = window.dtrum;
    const formatLog = (data) => typeof data === 'string' ? data : JSON.stringify(data);
    const identifyUser = (name) => {
        if (dtrum) {
            dtrum.identifyUser(name);
        }
        else {
            onErrorCallBack &&
                onErrorCallBack('window.dtrum is undefined, unable to identify user: ' + name);
        }
    };
    const logInfo = (name, description) => {
        let log = `WEB - ${applicationName} - ${name}`;
        if (description) {
            log = `${log} - ${formatLog(description)}`;
        }
        if (dtrum) {
            const actionId = dtrum.enterAction(`${applicationName} - INFO - ${name}`);
            dtrum.actionName(log, actionId);
            dtrum.leaveAction(actionId);
        }
        else {
            onErrorCallBack &&
                onErrorCallBack('window.dtrum is undefined, unable to send: ' + log);
        }
    };
    const logError = (name, errorDescripton) => {
        const log = `WEB - ${applicationName} - ${name}`;
        if (dtrum) {
            const actionId = dtrum.enterAction(log);
            dtrum.reportError(log, actionId);
            if (errorDescripton) {
                dtrum.reportError(errorDescripton, actionId);
            }
            dtrum.leaveAction(actionId);
        }
        else {
            onErrorCallBack &&
                onErrorCallBack('window.dtrum is undefined, unable to send: ' + log);
        }
    };
    return {
        identifyUser,
        logInfo,
        logError,
    };
};
